import BindingContext from "@odata/BindingContext";
import { IPrPayrollPeriodEntity, PrSalaryAdvanceEntity } from "@odata/GeneratedEntityTypes";

export const MonthYearLocalPath = BindingContext.localContext("MonthYear");

export function getSalaryAdvancePeriodFilter(period: IPrPayrollPeriodEntity): string {
    return period ? `${PrSalaryAdvanceEntity.Month} eq ${period.Month} and ${PrSalaryAdvanceEntity.Year} eq ${period.Year}` : null;
}